import * as actionTypes from "../actionTypes/Index";
import { agentManagementInitialState } from "./InitialState";
import { IActionType } from "../../interfaces/Index";

const initialState = { ...agentManagementInitialState };

export const appendUpdateAgentManagementUsers = (payload: any, state: any) => {
  if (payload.isPaginatedRes) {
    return [...state.agentManagementUsers, ...payload.agentManagementUserData];
  }
  return payload.agentManagementUserData.slice();
};

export default function agentManagementUserReducer(
  state = initialState,
  action: IActionType
) {
  switch (action.type) {
    case actionTypes.CREATE_AGENT_MANAGEMENT_USERS_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isAgentManagementUserAdded: false,
        error: null,
      });
    }
    case actionTypes.CREATE_AGENT_MANAGEMENT_USERS_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        isAgentManagementUserAdded: true,
        agentManagementUserDetails: null,
      });
    }
    case actionTypes.CREATE_AGENT_MANAGEMENT_USERS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        agentManagementUsers: null,
        error: action.error,
      });
    }
    case actionTypes.GET_AGENT_MANAGEMENT_USERS_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isAgentManagementUserUpdated: false,
        isAgentManagementUserAdded: false,
        error: null,
      });
    }
    case actionTypes.GET_AGENT_MANAGEMENT_USERS_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        agentManagementUsers: appendUpdateAgentManagementUsers(
          action.payload,
          state
        ),
        pagination: (action.payload! as any).pagination,
      });
    }
    case actionTypes.GET_AGENT_MANAGEMENT_USERS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        agentManagementUsers: null,
        error: action.error,
      });
    }
    case actionTypes.GET_AGENT_MANAGEMENT_USER_DETAIL_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isagentManagementUserDetailsFetched: false,
        agentManagementUserDetails: null,
        error: null,
      });
    }
    case actionTypes.GET_AGENT_MANAGEMENT_USER_DETAIL_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        isagentManagementUserDetailsFetched: true,
        agentManagementUserDetails: action.payload,
      });
    }
    case actionTypes.GET_AGENT_MANAGEMENT_USER_DETAIL_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isagentManagementUserDetailsFetched: false,
        error: action.error,
      });
    }
    case actionTypes.UPDATE_AGENT_MANAGEMENT_USERS_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isAgentManagementUserUpdated: false,
        error: null,
      });
    }
    case actionTypes.UPDATE_AGENT_MANAGEMENT_USERS_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        isAgentManagementUserUpdated: true,
        agentManagementUserDetails: [],
      });
    }
    case actionTypes.UPDATE_AGENT_MANAGEMENT_USERS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isAgentManagementUserUpdated: false,
        error: action.error,
      });
    }
    case actionTypes.GET_ALL_AGENT_TEAM_ZONES_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isAllAgentZonesFetched: false,
        allAgentZones: null,
        error: null,
      });
    }
    case actionTypes.GET_ALL_AGENT_TEAM_ZONES_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        isAllAgentZonesFetched: true,
        allAgentZones: action.payload,
      });
    }
    case actionTypes.GET_ALL_AGENT_TEAM_ZONES_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isAllAgentZonesFetched: false,
        allAgentZones: null,
        error: action.error,
      });
    }
    case actionTypes.GET_AGENT_TITLE_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        agentTitle: [],
      });
    }
    case actionTypes.GET_AGENT_TITLE_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        isError: false,
        agentTitle: action.payload,
      });
    }
    case actionTypes.GET_AGENT_TITLE_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        agentTitle: [],
        isError: true,
      });
    }
    case actionTypes.GET_AGENT_TEAM_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        agentTeam: [],
      });
    }
    case actionTypes.GET_AGENT_TEAM_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        isError: false,
        agentTeam: action.payload,
      });
    }
    case actionTypes.GET_AGENT_TEAM_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        agentTeam: [],
        isError: true,
      });
    }
    case actionTypes.GET_BRANDS_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        brands: [],
      });
    }
    case actionTypes.GET_BRANDS_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        isError: false,
        brands: action.payload,
      });
    }
    case actionTypes.GET_BRANDS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        brands: [],
        isError: true,
      });
    }
    default:
      return state;
  }
}
